import ReactDOM from 'react-dom';
import { useEffect, useState } from 'react';

const StoreCashModal = ({ isOpen, onClose, children }) => {
  const [showContent, setShowContent] = useState(false);

 
    useEffect(() => {
      if (isOpen) {
        setShowContent(true);
        document.body.classList.add('storecashmodal-open');
      } else if (!isOpen) {
        setShowContent(false);
        document.body.classList.remove('storecashmodal-open');
      }
    }, [isOpen]);

  if (!isOpen) return null;

  const modal__classList = `StoreCashModal ${showContent ? 'showModal' : ''}`
  const overlay__classList = `StoreCashModal__overlay ${showContent ? 'showoverlay' : ''}`

  const handleClose = (e) => {
    e.preventDefault()
    setShowContent(false);
    document.body.classList.remove('storecashmodal-open')
    setTimeout(() => {
      onClose(e);
    }, 500)
  }

  return ReactDOM.createPortal(
    <div className={overlay__classList} onClick={handleClose}>
      <div className={modal__classList} onClick={(e) => e.stopPropagation()}>
        <button onClick={handleClose} className="StoreCashModal__close-button">
          <span className="StoreCashModal__close-icon">&times;</span>
        </button>
        <div className="minicart-modal__content line-height-sml">
          <div className="minicart-modal__content-inner">{children}</div>
        </div>
      </div>
    </div>,
    document.getElementById('modal-container')
  );
};

export default StoreCashModal;
